require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/node_modules/core-js/modules/es6.array.species.js
// module id = ../../../../core-js/modules/es6.array.species.js
// module chunks = polyfills